import { createCustomerDisplayServerPlugin } from '@pos-common/classes';

export const CustomerDisplayPlugin = createCustomerDisplayServerPlugin();
